import React from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import usePrompts from 'components/Admin/Prompts/Hooks/usePrompts';
import ListPage from './Pages/List/Index';
import CreatePage from './Pages/Create/Index';
import UpdatePage from './Pages/Update/Index';

export default function Index() {
  const { prompts, refresh } = usePrompts();
  return (
    <Router>
      <Routes>
        <Route path="/admin/prompts" element={<ListPage prompts={prompts} refresh={refresh} />}>
          <Route path="new" element={<CreatePage refresh={refresh} />} />
          <Route path=":id/edit" element={<UpdatePage refresh={refresh} />} />
        </Route>
      </Routes>
    </Router>
  );
}
